// extracted by mini-css-extract-plugin
export default {"container":"ModalServiceError_container__Ze++v","description":"ModalServiceError_description__AIUgX","checkbox":"ModalServiceError_checkbox__I9dQJ"};